function registerInfiniteScrollLoadMoreButton() {
  const loadMoreButton = document.querySelector(".js-load-more");
  const loadMoreContainer = document.querySelector(".LoadMore--container");
  const currentItemCount = loadMoreContainer.querySelector(
    ".current-item-count"
  );

  if (loadMoreButton == null) {
    return;
  }

  loadMoreButton.addEventListener("click", (e) => {
    const totalPages = document.querySelector("[data-total-pages]");
    const totalPagesValue = parseInt(totalPages.value);
    let currentPage = document.querySelector("[data-current-page]");
    let currentPageValue = parseInt(currentPage.value);
    let nextUrl = document.querySelector("[data-next-url]");
    let pageSize = document.querySelector("[data-total-page-size]");
    let pageSizeValue = parseInt(pageSize.value);

    loadMoreButton.setAttribute("disabled", true);
    loadMoreButton.classList.remove("button--primary");
    loadMoreButton.classList.add("button--secondary");

    const loadMoreText = loadMoreButton.querySelector("[load-more-text");
    const loaderText = loadMoreButton.querySelector("[loader-text");

    loadMoreText.classList.add("hidden");
    loaderText.classList.remove("hidden");

    fetch(nextUrl.value)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        if (
          window.location.href.includes("collections") ||
          window.location.href.includes("search")
        ) {
          const products = doc.querySelectorAll(".product-grid > .grid__item:not(.breaker_item)");
          const productList = document.querySelector(".product-grid");

          var isSafari = window.safari !== undefined;

          if (products) {
            products.forEach((product) => {
              if (isSafari) {
                const images = product.querySelectorAll(".card__media img");

                images.forEach((_) => {
                  _.removeAttribute("srcset");
                });
              }

              productList.append(product);

              // Start any video that is in the product
              const video = product.querySelector("video");
              if (video) {
                video.play();
              }
            });
          }
        } else if (window.location.href.includes("blogs")) {
          const articles = doc.querySelectorAll(
            ".blog-articles > .blog-articles__article"
          );
          const allArticles = document.querySelectorAll(
            ".blog-articles__article"
          );
          const lastArticle = allArticles[allArticles.length - 1];

          articles?.forEach((article) => {
            lastArticle.appendChild(article);
          });
        }

        nextUrl.value = nextUrl.value.replace(
          `page=${currentPageValue + 1}`,
          `page=${currentPageValue + 2}`
        );
        currentPage.value = currentPageValue + 1;
        if (currentItemCount) {
          currentItemCount.innerHTML = String(
            (currentPageValue + 1) * pageSizeValue
          );
        }

        if (currentPage.value >= totalPagesValue) {
          document.querySelector(".LoadMore--container").remove();
        } else {
          loadMoreButton.removeAttribute("disabled");
          loadMoreButton.classList.add("button--primary");
          loadMoreButton.classList.remove("button--secondary");
          loadMoreText.classList.remove("hidden");
          loaderText.classList.add("hidden");
        }
      })
      .catch((error) => {
        console.warn("Loading more failed", error);
        document.querySelector(".LoadMore--container").remove();
      });
  });
}

registerInfiniteScrollLoadMoreButton();
